import { removeClass } from '../../js/shared/utils';

(function() {

    // открыть/закрыть кейс

    if (!document.querySelector('.brief__header')) {
        return;
    }

    document.addEventListener('click', e => {
        const briefHeader = e.target.closest('.brief__header');
        if (!briefHeader) {
            return;
        }

        const brief = briefHeader.closest('.brief');
        const briefcase = brief.closest('.briefcase');
        const allBriefs = briefcase.querySelectorAll('.brief');

        removeClass(allBriefs, 'is-opened');
        brief.classList.add('is-opened');
    });

}());